import { useTranslation } from "react-i18next";
import Section from "../../Atoms/Section";
import { useEffect, useRef, useState } from "react";
import BlueButton from "../../Atoms/BlueButton";
import * as api from '../../../api';
import Step1 from "../../Components/FD10025/Step1";
import Step2 from "../../Components/FD10025/Step2";
import { useNavigate } from "react-router-dom";
import { NeedToPay, validateStep1FD1002025 } from "../../Utils/Validator";
import Spinner from "../../../Plateforme/Atoms/Spinner";
import BigH1 from "../../Atoms/BigH1";
import Popup from "../../Atoms/Popup";
import H2 from "../../Atoms/H2";
import UploadProgressBar from "../../Atoms/UploadProgressBar";
import PaymentPopup from "../../Components/PaymentPopup";

const RegisterFD1002025 = (props) => {

    const navigate = useNavigate()

    const [projets, setProjets] = useState([]);
    const [deletedProjets, setDeletedProjets] = useState([]);
    const [PaymentPopupOpen, setPaymentPopupOpen] = useState(false);

    const [step, setStep] = useState(1);
    const formRef = useRef(null);
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [dataSavedPopupOpen, setDataSavedPopupOpen] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);


    //parse eid from url and get event
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                setEvent(response.data);
                setLoading(false);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    //scroll to top on step change
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [step])

    const { i18n } = useTranslation('common');

    function submit(e) {
        e.preventDefault();
        
        if (!props.fullUser || !props.fullUser.user) {
            alert("Please login to register");
            return;
        }

        if(!validateStep2()){
            setLoading(false);
            return;
        }

        api.LogFront("FD1002025 start submit (in register)");

        const totalSizeOfFiles = projets.reduce((acc, projet) => {
            if(projet.newMedias){
                return acc + projet.newMedias.reduce((acc2, media) => {
                    return acc2 + media.file.size;
                }, 0);
            }
            return acc;
        }, 0);
        api.LogFront("totalSizeOfFiles : " + totalSizeOfFiles);

        setLoading(true);
        const submission = new FormData(e.target);


        if (props.fullUser.user.role === "admin"){
            alert("Les administrateurs ne peuvent pas s'inscrire à un événement");
            return;
        }

        submission.append("projets", JSON.stringify(projets));
        for (let i = 0; i < projets.length; i++) {
            // console.log("appending projet")
            // console.log(projets[i])
            if(projets[i].newMedias){
                for (let j = 0; j < projets[i].newMedias.length; j++) {
                    // console.log("appending file")
                    // console.log(projets[i].newMedias[j])
                    submission.append("file_" + projets[i].id_in_participation + "_" + j, projets[i].newMedias[j].file);
                }
            }
        }
        submission.append("userId", props.fullUser.user._id);
        submission.append("eventId", event._id);

        //start a timer to see how long it takes to upload
        const startTime = new Date().getTime();

        api.saveFD1002025(submission, onUploadProgress).then((response) => {
            console.log("response.data")
            console.log(response.data)
            setLoading(false);
            if (response.data === "success") {
                props.refreshUser();
                setDataSavedPopupOpen(true);
            } else {
                api.LogFront("❌ FD1002025 error on submit (in register) : " + response.data);
                
                alert("Erreur lors de l'enregistrement des données, assurez-vous que les fichiers ne dépassent pas 50Mo");
            }
        }).catch((error) => {
            const endTime = new Date().getTime();
            const timeOfCrash = endTime - startTime;

            console.log(error);
            api.LogFront("❌ FD1002025 error on submit (in edit) : " + error);
            api.LogFront("at uploadProgress : " + uploadProgress);
            api.LogFront("time of crash : " + timeOfCrash);

            //if the error is a network error, we can assume the user lost connection
            if (error.message === "Network Error") {
                alert("Erreur lors de l'enregistrement des données. Veuillez vérifier votre connexion internet et réessayer.");
                setLoading(false);
                return;
            }

            alert("Erreur lors de l'enregistrement des données. Veuillez contacter connectedby@via.fr si le problème persiste.");
        });
    }

    function onUploadProgress(progressEvent){
        const percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        setUploadProgress(percentCompleted);
    }

    function nextStep() {
        api.LogFront("FD1002025 next step (in register), step before we go to next one : " + step);
        if (step === 1 && validateStep1()) {
            setStep(step + 1);
        }
    }

    function validateStep1() {
        api.LogFront("FD1002025 validate step 1 (in register)");
        const form = new FormData(formRef.current);
        return validateStep1FD1002025(form,projets);
    }

    function validateStep2() {
        api.LogFront("FD1002025 validate step 2 (in register) with projets :" + projets.length);
        //check thate there is at least one projet
        if (projets.length === 0) {
            alert(i18n.language === "fr" ? "Vous devez ajouter au moins un projet" : "You must add at least one project");
            return false;
        }

        return true;
    }

    if (loading) {
        return <Section className="padding">
            <Spinner/><br/>
            <UploadProgressBar uploadProgress={uploadProgress}/>
        </Section>
    }

    //if user doesnt have a company alert that they need to create one first
    if (props.fullUser && !props.fullUser.company) {
        return <Section className="padding"><H2>{i18n.language === "fr" ? "Vous devez créer une entreprise avant de vous inscrire à un événement" : "You need to create a company before registering for an event"}</H2></Section>
    }

    function companyIsFabOrEditor(){
        console.log(props.fullUser)
        const cat_gorie_via = props.fullUser?.hsCompany?.properties?.cat_gorie_via;
        if(!cat_gorie_via) return false;
        const lowerCased = cat_gorie_via.toLowerCase();
        if(lowerCased.includes("créateur")) return false;
        if(lowerCased.split(";").length > 1) return false;
        return lowerCased.includes("éditeur") || lowerCased.includes("editeur") || lowerCased.includes("fabricant");
    }

    //if the user has a company but it's cat_gorie_via contains "éditeur", "editeur", or "fabricant", they cannot register
    if (props.fullUser && companyIsFabOrEditor()) {
        return <Section className="padding centered">
                <H2>{i18n.language === "fr" ? "Les éditeurs et fabricants ne peuvent pas s'inscrire à cet événement." : "Publishers and manufacturers cannot register for this event."}</H2>
                <br/>
                <>{i18n.language === "fr" ? "Le palmarès est ouvert aux designers, architectes d’intérieur, et architectes, exerçant en indépendant, en studio, en agence ou intégré en entreprise." : "The awards are open to designers, interior architects, and architects, working independently, in a studio, in an agency, or integrated into a company."}</>
                <br/>
                <>{i18n.language === "fr" ? "Si vous êtes éditeur ou fabricant et que vous souhaitez inscrire vos designers, merci de nous appeler au numéro suivant : 01 44 68 18 00" : "If you are a publisher or manufacturer and you wish to register your designers, please call us at the following number: 01 44 68 18 00"}</>
            </Section>
    }

    //if user is admin, they cannot register
    if (props.fullUser && props.fullUser.user.role === "admin") {
        return <Section className="padding"><H2>{i18n.language === "fr" ? "Vous ne pouvez pas vous inscrire à un événement depuis un compte administrateur." : "You cannot register for an event from an admin account."}</H2></Section>
    }

    return (<>
         <Section className="padding flexblock" style={{ justifyContent: 'center', gap: '20px', alignItems: 'center' }}>
            <img src={process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + event.logo_path} alt="Event Logo" style={{maxWidth:"150px"}} />
            <div>
                <BigH1 style={{fontSize:"65px", lineHeight:"70px", marginBottom:"20px"}}>{event.title_fr}</BigH1>
                <span style={{fontSize:"22px"}}>{i18n.language === "fr" ? "Voici les informations que vous avez saisi pour votre participation à cet événement. Vous pouvez les modifier si nécessaire." : "Here is the information you entered for your participation in this event. You can modify it if necessary."}</span>
            </div>
        </Section>
        {props.fullUser && 
            <form onSubmit={submit} ref={formRef}>
                <Section className="padding" style={{ display: step === 1 ? 'block' : 'none' }}>
                    <Step1 />
                </Section>
                <Section className="padding" style={{ display: step === 2 ? 'block' : 'none' }}>
                    <Step2 fullUser={props.fullUser} projets={projets} setProjets={setProjets} deletedProjets={deletedProjets} setDeletedProjets={setDeletedProjets} />
                    {step === 2 && <div style={{ color: "red" }} className="centered">{i18n.language === "fr" ? "Votre candidature n'est pas encore enregistrée. Pour enregistrer votre candidature, cliquez sur le bouton 'Enregistrer'." : "Your application is not yet saved. To save your application, click on the 'Save' button."}</div>}
                </Section>
                <Section className="padding flexblock" style={{ justifyContent: 'center', gap: '40px' }}>
                    {step > 1 && <BlueButton onClick={(e) => { e.preventDefault(); setStep(step - 1) }}>{i18n.language === "fr" ? "Précédent" : "Previous"}</BlueButton>}
                    {step < 2 && <BlueButton onClick={(e) => { e.preventDefault(); nextStep() }}><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Suivant" : "Next"}</BlueButton>}
                    {step === 2 && <BlueButton>{i18n.language === "fr" ? "Enregistrer" : "Save"}</BlueButton>}
                </Section>
            </form>
        }
        {dataSavedPopupOpen && 
            <Popup close={() => navigate("/evenements")}>
                <H2>{i18n.language === "fr" ? "Candidature enregistrée" : "Application saved"}</H2>
                {NeedToPay(props.fullUser?.hsProfile) && <>
                    <br/>
                    <span>{i18n.language === "fr" ? "Vous souhaitez profiter de nos services tels que l'accès à notre annuaire et aux resources exclusives ?" : "Would you like to take advantage of our services such as access to our directory and exclusive resources?"}</span>
                    <br/>
                    <BlueButton onClick={() => setPaymentPopupOpen(true)}>
                        {i18n.language === "fr" ? "Devenez membre" : "Become a member"}
                    </BlueButton>
                </>}
                <br/>
                <BlueButton onClick={() => navigate("/evenements")}>
                    {i18n.language === "fr" ? "Fermer" : "Close"}
                </BlueButton>
            </Popup>
        }
        {PaymentPopupOpen && <setPaymentPopupOpen close={() => setPaymentPopupOpen(false)} email={props.fullUser?.hsProfile?.email}/>}
    </>)
}

export default RegisterFD1002025;